/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: gNk1RWPoHev5
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicOp1WebAwButton.module.css"; // plasmic-import: gNk1RWPoHev5/css
import image69J1Gn9IoaMnpw from "./images/image69.svg"; // plasmic-import: j1GN9IoaMnpw/picture

createPlasmicElementProxy;

export const PlasmicOp1WebAwButton__VariantProps = new Array("status");

export const PlasmicOp1WebAwButton__ArgProps = new Array(
  "onClick",
  "icon",
  "windowId"
);

const $$ = {};

function PlasmicOp1WebAwButton__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          icon: {
            src: image69J1Gn9IoaMnpw,
            fullWidth: 1,
            fullHeight: 1,
            aspectRatio: undefined
          }
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.status
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__nJ1Nn",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      type={"button"}
    >
      <div
        data-plasmic-name={"iconWrapper"}
        data-plasmic-override={overrides.iconWrapper}
        className={classNames("all", sty.iconWrapper, {
          [sty.iconWrapperstatus_active]: hasVariant(
            $state,
            "status",
            "active"
          ),
          [sty.iconWrapperstatus_open]: hasVariant($state, "status", "open")
        })}
      >
        <PlasmicImg__
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          alt={""}
          className={classNames(sty.img)}
          displayHeight={"100%"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"100%"}
          loading={"lazy"}
          src={(() => {
            try {
              return $props.icon.src;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        />
      </div>
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames("all", sty.freeBox, {
          [sty.freeBoxstatus_active]: hasVariant($state, "status", "active"),
          [sty.freeBoxstatus_open]: hasVariant($state, "status", "open")
        })}
      />
    </button>
  );
}

const PlasmicDescendants = {
  root: ["root", "iconWrapper", "img", "freeBox"],
  iconWrapper: ["iconWrapper", "img"],
  img: ["img"],
  freeBox: ["freeBox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOp1WebAwButton__ArgProps,
          internalVariantPropNames: PlasmicOp1WebAwButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOp1WebAwButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOp1WebAwButton";
  } else {
    func.displayName = `PlasmicOp1WebAwButton.${nodeName}`;
  }
  return func;
}

export const PlasmicOp1WebAwButton = Object.assign(
  // Top-level PlasmicOp1WebAwButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    iconWrapper: makeNodeComponent("iconWrapper"),
    img: makeNodeComponent("img"),
    freeBox: makeNodeComponent("freeBox"),
    // Metadata about props expected for PlasmicOp1WebAwButton
    internalVariantProps: PlasmicOp1WebAwButton__VariantProps,
    internalArgProps: PlasmicOp1WebAwButton__ArgProps
  }
);

export default PlasmicOp1WebAwButton;
/* prettier-ignore-end */
